import React from 'react';
import { StyleSheet } from 'react-native';
import { DNAText, GridList, util } from '@alucio/lux-ui';
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors';
import { COLUMN_CONFIG, FolderHeaderType, FolderVariants } from 'src/screens/MyFolders/constants';
import { SortDir } from 'src/components/DNA/hooks/useSort';
import { SortableGridListHeaderText } from '../GridListColumnHeaderRow';
import { useAppSettings } from 'src/state/context/AppSettings';

const styles = StyleSheet.create({
  headerContainer: {
    backgroundColor: colors['color-ui2-neutral-50'],
    paddingHorizontal: 8,
    height: 40,
  },
  stickyHeader: {
    position: 'sticky' as any,
    top: 0,
    zIndex: 10,
  },
  text: {
    color: colors['color-text-light-primary'],
  },
})

interface GridListFolderHeaderRowProps {
  variant?: FolderVariants
  toggleSort?: (key: FolderHeaderType) => void
  sortDir?: SortDir
  sortKey?: FolderHeaderType
}

const DISPLAYABLE_HEADER_TEXT = [FolderHeaderType.OWNER];
const SORTABLE_HEADER_TEXT = [FolderHeaderType.NAME, FolderHeaderType.UPLOADED, FolderHeaderType.UPDATED];

export const GridListFolderHeaderRow: React.FC<GridListFolderHeaderRowProps> = (props) => {
  const { variant = FolderVariants.DEFAULT, toggleSort, sortDir, sortKey } = props;
  const { deviceMode } = useAppSettings();
  const isTablet = deviceMode === 'tablet';

  return (
    <GridList.Header
      style={util.mergeStyles(
        undefined,
        styles.headerContainer,
        [styles.stickyHeader, isTablet],
      )}
    >
      {COLUMN_CONFIG[variant].columns.map(headerText => {
        if (DISPLAYABLE_HEADER_TEXT.includes(headerText)) {
          return (
            <GridList.Col key={headerText}>
              <DNAText bold testID={`folder-header-col-${headerText}`} style={styles.text}>
                {headerText}
              </DNAText>
            </GridList.Col>
          )
        } else if (SORTABLE_HEADER_TEXT.includes(headerText)) {
          const isActive = sortKey === headerText;
          return (
            <GridList.Col key={headerText}>
              <SortableGridListHeaderText
                lable={headerText}
                isSortedAsc={sortDir === SortDir.asc}
                onPress={() => toggleSort?.(headerText)}
                isActive={isActive}
              />
            </GridList.Col>
          )
        } else return <GridList.Col key={headerText}/>
      })}
    </GridList.Header>
  )
}

export default GridListFolderHeaderRow
